import { theme } from '@/theme/theme';
import { useMediaQuery, type UseMediaQueryOptions } from '@mui/material';

export type Devices = 'mobile' | 'desktop' | 'tablet';

export const DOWN_1000 = theme.breakpoints.down(1000);

export const devices: Record<Devices, string> = {
  // Match [lg, ∞)
  //       [1248, ∞)
  desktop: theme.breakpoints.up('lg'),

  // 600px < x < 900px
  tablet: theme.breakpoints.down('md'),

  // Match [0, lg)
  //       [0, 600px)
  mobile: theme.breakpoints.down('sm'),
};

export const useBreakpoint = (
  device: Devices,
  opts?: UseMediaQueryOptions & { uaDevice?: Devices }
) => {
  const isTheDevice = useMediaQuery(devices[device], {
    ...opts,
    defaultMatches: opts?.uaDevice === device,
  });

  return isTheDevice;
};
